module.exports = __webpack_public_path__ + "img/icon-activity.ac11007b.png";